import hat from '../images/main/hat.svg'
import plus from '../images/main/plus.svg'
import peoples from '../images/main/peoples.svg'
import graph from '../images/main/graph.svg'
import doctor from '../images/main/doctor.svg'
import party from '../images/main/party.svg'
import { HashRouter, generatePath } from 'react-router-dom'

export const mainInformation = [
  {
    id: 1,
    title: 'Сильная команда',
    img: peoples,
    text: 'Сообщество профессионалов мирового уровня'
  },
  {
    id: 2,
    title: 'Культура развития',
    img: hat,
    text: 'Корпоративная система обучения и управления знаниями'
  },
  {
    id: 3,
    title: 'Конкурентные условия',
    img: graph,
    text: 'Ежегодное премирование и пересмотр оклада'
  },
  {
    id: 4,
    title: 'Медицинская страховка',
    img: plus,
    text: 'Для сотрудников и их семей'
  },
  {
    id: 5,
    title: 'Консультации с врачами',
    img: doctor,
    text: 'Прямо на рабочем месте'
  },
  {
    id: 6,
    title: 'Корпоративный досуг',
    img: party,
    text: 'Спортивные команды и клубы по интересам'
  },
]
